var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../../libs/gojs/release/go';
import { LineElement } from '../base/line-element';
import { DiagramConsts } from '../../diagram-consts';
var StraightLineElement = /** @class */ (function (_super) {
    __extends(StraightLineElement, _super);
    function StraightLineElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StraightLineElement.prototype.compile = function (model, data, _svg) {
        model['version'] = 4;
        model['strokeWidth'] = data.strokeWidth;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    StraightLineElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/straightLine.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    StraightLineElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            resizable: true, resizeObjectName: 'SHAPE',
            selectionAdorned: true, selectionObjectName: 'SHAPE',
            reshapable: true, locationObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder, new go.Binding('padding', '', function (data) {
                return -data.strokeWidth / 2;
            }))))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('zOrder'), $(go.Shape, { name: 'SHAPE', stroke: 'black', strokeWidth: 1, geometryString: 'M 0 0 100 0', isPanelMain: true }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('stroke'), new go.Binding('geometryString', 'geo').makeTwoWay(), new go.Binding('strokeWidth'), new go.Binding('strokeDashArray', '', function (data) {
            return _this.getStrokeDasharray(data.lineType);
        })), this.makeStartArrowHeader(), this.makeEndArrowHeader());
    };
    StraightLineElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.straightLineKey;
    };
    StraightLineElement.prototype.makeStartArrowHeader = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Shape, new go.Binding('scale', '', function (data) {
            return data.strokeWidth !== 1 ? data.strokeWidth / 2 : 1;
        }), new go.Binding('visible', '', this.isStartArrowVisible), new go.Binding('geometry', 'arrowStyle', function (arrowStyle) {
            return _this.getStartArrow(arrowStyle);
        }), new go.Binding('angle', '', function (data) {
            if (!_this.isStartArrowVisible(data)) {
                return undefined;
            }
            return _this.getArrowAngle(data, true);
        }), new go.Binding('alignment', '', function (data) {
            if (!_this.isStartArrowVisible(data)) {
                return undefined;
            }
            return _this.getArrowAlignment(data, true);
        }), new go.Binding('alignmentFocus', '', function (data) {
            if (!_this.isStartArrowVisible(data)) {
                return undefined;
            }
            return _this.getAlignmentFocus(data, true);
        }), new go.Binding('stroke'), new go.Binding('fill', 'stroke'), new go.Binding('strokeWidth', '', function (data) {
            return data.strokeWidth !== 1 ? 2 : 1;
        }));
    };
    StraightLineElement.prototype.makeEndArrowHeader = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Shape, new go.Binding('scale', '', function (data) {
            return data.strokeWidth !== 1 ? data.strokeWidth / 2 : 1;
        }), new go.Binding('visible', '', this.isEndArrowVisible), new go.Binding('geometry', 'arrowStyle', function (arrowStyle) {
            return _this.getEndArrow(arrowStyle);
        }), new go.Binding('angle', '', function (data) {
            if (!_this.isEndArrowVisible(data)) {
                return undefined;
            }
            return _this.getArrowAngle(data, false);
        }), new go.Binding('alignment', '', function (data) {
            if (!_this.isEndArrowVisible(data)) {
                return undefined;
            }
            return _this.getArrowAlignment(data, false);
        }), new go.Binding('alignmentFocus', '', function (data) {
            if (!_this.isEndArrowVisible(data)) {
                return undefined;
            }
            return _this.getAlignmentFocus(data, false);
        }), new go.Binding('stroke'), new go.Binding('fill', 'stroke'), new go.Binding('strokeWidth', '', function (data) {
            return data.strokeWidth !== 1 ? 2 : 1;
        }));
    };
    return StraightLineElement;
}(LineElement));
export { StraightLineElement };
